import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function ServicesSection({ form, setForm, isEditable }) {
  const s = (field, val) => setForm({ ...form, [field]: val });

  return (
    <div className="card-surface p-5 space-y-4">
      <h2 className="text-sm font-semibold font-['Outfit'] text-zinc-500 uppercase tracking-wider">Servizi e Materiali</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-3">
          <p className="text-xs font-semibold text-zinc-700">Materiali Imballo</p>
          <div className="grid grid-cols-2 gap-2">
            {[["packing_large", "Formato Grande"], ["packing_medium", "Formato Medio"], ["packing_small", "Formato Piccolo"], ["packing_clothes", "Vestiti"]].map(([key, label]) => (
              <div key={key} className="space-y-1">
                <Label className="text-xs text-zinc-500">{label}</Label>
                <Input data-testid={key.replace("_", "-")} type="number" min="0" value={form[key]} onChange={(e) => s(key, parseInt(e.target.value) || 0)} disabled={!isEditable} className="rounded-sm" />
              </div>
            ))}
          </div>
          <div className="space-y-1 pt-2 border-t border-zinc-100">
            <Label className="text-xs text-zinc-500">Costo Materiali (€)</Label>
            <Input data-testid="materials-cost" type="number" min="0" step="0.01" placeholder="0 €"
              value={form.materials_cost || 0}
              onChange={(e) => s("materials_cost", parseFloat(e.target.value) || 0)}
              disabled={!isEditable} className="rounded-sm" />
            <span className="text-[10px] text-zinc-400 italic leading-tight block">Costo unico per tutti i materiali utilizzati. Concorre al totale.</span>
          </div>
        </div>
        <div className="space-y-3">
          <p className="text-xs font-semibold text-zinc-700">Servizi</p>
          <div className="space-y-2">
            {[["packing_household", "Imballo masserizie"], ["packing_furniture", "Imballo mobili"], ["disassembly", "Smontaggio"], ["assembly", "Montaggio"]].map(([key, label]) => (
              <label key={key} className="flex items-center gap-2 text-sm cursor-pointer">
                <input type="checkbox" checked={form[key]} onChange={(e) => s(key, e.target.checked)} disabled={!isEditable} data-testid={`service-${key}`} className="rounded-sm" />
                {label}
              </label>
            ))}
          </div>
          <div className="space-y-2 pt-2 border-t border-zinc-100">
            <label className="flex items-center gap-2 text-sm cursor-pointer">
              <input type="checkbox" checked={form.insurance_requested} onChange={(e) => s("insurance_requested", e.target.checked)} disabled={!isEditable} data-testid="insurance-requested" className="rounded-sm" />
              Assicurazione
            </label>
            {form.insurance_requested && (
              <Input data-testid="insurance-amount" type="number" min="0" step="0.01" placeholder="Importo assicurazione €" value={form.insurance_amount} onChange={(e) => s("insurance_amount", parseFloat(e.target.value) || 0)} disabled={!isEditable} className="rounded-sm" />
            )}
          </div>
          <div className="space-y-1 pt-2 border-t border-zinc-100">
            <Label className="text-xs text-zinc-500">Giorni necessari alla lavorazione</Label>
            <Input data-testid="work-days" type="number" min="0" value={form.work_days} onChange={(e) => s("work_days", parseInt(e.target.value) || 0)} disabled={!isEditable} className="rounded-sm" />
          </div>
        </div>
      </div>
    </div>
  );
}
